// /**
//  * Language dropdown controller
//  * Abre/cierra el selector de idioma y lo cierra al clicar fuera
//  */
// export function initLangDropdown() {

//   const toggle = document.querySelector('[data-toggle-button]');
//   if (!toggle) return;

//   const submenu = document.querySelector('.nav-lang .sub-menu');
//   if (!submenu) return;

//   const icon = toggle.parentElement?.querySelector('svg');
//   if (!icon) return;

//   const label = toggle.closest('label');

//   toggle.addEventListener('change', () => {
//     submenu.classList.toggle('is-open', toggle.checked);
//     icon.classList.toggle('is-rotate', toggle.checked);
//   });

//   document.addEventListener('click', (event) => {
//     const clickedInsideLabel = label?.contains(event.target);
//     const clickedInsideMenu = submenu.contains(event.target);

//     if (!clickedInsideLabel && !clickedInsideMenu) {
//       toggle.checked = false;
//       submenu.classList.remove('is-open');
//       icon.classList.remove('is-rotate');
//     }
//   });

// }
/**
 * Language dropdown controller
 * Abre/cierra el selector de idioma y lo cierra al clicar fuera
 */
export function initLangDropdown() {

  const toggle = document.querySelector('[data-toggle-button]');
  if (!toggle) return;
  const label = toggle.closest('label');
  if (!label) return;
  const submenu = label.querySelector('.nav-lang .sub-menu');
  if (!submenu) return;
  const icon = label.querySelector('svg');
  if (!icon) return;
  const currentLangLink = label.querySelector('.wpml-ls-current-language > a');
  if (!currentLangLink) return;

  /**
   * Sincroniza el estado visual del dropdown
   */
  const syncDropdownState = () => {
    submenu.classList.toggle('is-open', toggle.checked);
    icon.classList.toggle('is-rotate', toggle.checked);
  };

  toggle.addEventListener('change', () => {
    syncDropdownState();
  });

  currentLangLink.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    toggle.checked = !toggle.checked;
    syncDropdownState();
  });

  document.addEventListener('click', (event) => {
    const clickedInsideLabel = label.contains(event.target);
    const clickedInsideMenu = submenu.contains(event.target);

    if (!clickedInsideLabel && !clickedInsideMenu) {
      toggle.checked = false;
      syncDropdownState();
    }
  });

}